import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";

import ProfileCard from "./ProfileCard";
import ProfileRow from "./ProfileRow";
import MultiSelectChip from "../../common/profile/MultiSelectChip";
import SingleSelectField from "../../common/searchconsultant//SingleSelectField";
export default function SupplierInformationCard({

    data,
    errors,
    statuts = [],
    activityTypes,
    handleChange,
    onAddActivityType,
    onRemoveActivityType

}) {
const { t } = useTranslation();
const { language } = useLanguage();

    return (
        <ProfileCard
            title={t("monProfile.supplierInformation")}
            icon="bi-shop"
        >


            <ProfileRow

                type="number"

                label={t("monProfile.yearsOfExperience")}

                icon="bi-award"

                name="nbAnneesExperience"

                value={data.nbAnneesExperience}

                onChange={handleChange}

                error={errors.nbAnneesExperience}

            />

        </ProfileCard>

    );

}